hrd.HtmlFormFactory = hrd.HtmlAbstractFactory.extend({
	init: function(container, options) {
		var defaults = {
			impl: 'hrd.HtmlFormFactory',
			xlate: true
		};
		this._super($.extend(true, {}, defaults, options));
		this.$container = container != undefined ? $(container) : $('<div></div>');
		this.$fieldset = this.$container.find('fieldset'); // search if fieldset is somehow already present, otherwise creates it
		if (!this.$fieldset.exists()) {
			this.$fieldset = $('<fieldset></fieldset>');
			this.$container.append(this.$fieldset);
		}
	},
	debug: function() {
		console.log(this.$container.prop('outerHTML'));
	},
	empty: function() {
		this.$fieldset.empty();
		return this;
	},
	addLegend: function(legend, options) {
		options = options || {};
		var text = this.settings.xlate ? xlate(legend) : legend;
		var $legend = $('<legend></legend>').append($(`<span>${text}</span>`));
		this.$fieldset.append($legend);
		return this;
	},
	addFieldset: function(columns, options) {
		options = options || {};
		// check if columns is a valid value, only a subset can be used
		columns = (columns == undefined) ? 1 : columns;
		var $fld = $('<div class="fieldset"></div>');
		if (columns > 1) {
			$fld.addClass('fieldset-' + columns);
		}
		if (options.fsclass) {
			$fld.addClass(options.fsclass);
		}
		if (options.fsstyle) {
			$fld.css(options.fsstyle);
		}
		this.$fieldset.append($fld);
		this.currentFieldset = $fld;
		this.currentSubFieldset = undefined;
		this.currentColumns = columns;
		return this;
	},
	createFieldset: function(columns, options) {
		options = options || {};
		// check if columns is a valid value, only a subset can be used
		columns = (columns == undefined) ? 1 : columns;
		var $fld = $('<div class="fieldset"></div>');
		if (columns > 1) {
			$fld.addClass('fieldset-' + columns);
		}
		if (options.fsclass) {
			$fld.addClass(options.fsclass);
		}
		if (options.fsstyle) {
			$fld.css(options.fsstyle);
		}
		if (options.parentFieldSet) {
			options.parentFieldSet.append($fld);
		} else {
			this.$fieldset.append($fld);
		}
		this.currentFieldset = $fld;
		this.currentSubFieldset = undefined;
		this.currentColumns = columns;
		return $fld;
	},
	nestFieldset: function(parentFieldSet, columns, options) {
		options = options || {};
		// check if columns is a valid value, only a subset can be used
		columns = (columns == undefined) ? 1 : columns;
		var $fld = $('<div class="fieldset"></div>');
		if (columns > 1) {
			$fld.addClass('fieldset-' + columns);
		}
		if (options.fsclass) {
			$fld.addClass(options.fsclass);
		}
		if (options.fsstyle) {
			$fld.css(options.fsstyle);
		}
		parentFieldSet.append($fld);
		this.currentFieldset = $fld;
		this.currentSubFieldset = undefined;
		this.currentColumns = columns;
		return this;
	},
	addSubFieldset: function(length, options) {
		if (this.currentColumns > 1) {
			options = options || {};
			// check if length is a valid value, only a subset can be used
			length = (length == undefined) ? 1 : length;
			var $sfld = $('<div></div>');
			$sfld.addClass('fieldset-' + length + '-' + this.currentColumns);
			if (options.fsclass) {
				$sfld.addClass(options.fsclass);
			}
			if (options.fsstyle) {
				$sfld.css(options.fsstyle);
			}
			this.currentFieldset.append($sfld);
			this.currentSubFieldset = $sfld;
		} else {
			console.log('There is no need to use subFieldset in this context');
		}
		return this;
	},
	createSubFieldset: function(length, options) {
		var $sfld;
		if (this.currentColumns > 1) {
			options = options || {};
			// check if length is a valid value, only a subset can be used
			length = (length == undefined) ? 1 : length;
			$sfld = $('<div></div>');
			$sfld.addClass('fieldset-' + length + '-' + this.currentColumns);
			if (options.fsclass) {
				$sfld.addClass(options.fsclass);
			}
			if (options.fsstyle) {
				$sfld.css(options.fsstyle);
			}
			this.currentFieldset.append($sfld);
			this.currentSubFieldset = $sfld;
		} else {
			console.log('There is no need to use subFieldset in this context');
		}
		return $sfld;
	},
	addEmptyElement: function(options) {
		this._createComposite(options);
		return this;
	},
	addInputField: function(name, options) {
		options = options || {};
		var $composite = this._createComposite(options);
		var $field = $(`<input data-name="${name}"></input>`);
		if (options.id) {
			$field.attr('id', options.id);
		}
		if (options.fieldClass) {
			$field.addClass(options.fieldClass);
		}
		if (options.fieldStyle) {
			$field.css(options.fieldStyle);
		}

		this._addInputAttributes($field, options);

		if (options.labelOnRight !== true) {
			if (options.label || options.xlabel) {
				var $label = this._createLabel(options.label, options);
				$composite.append($label);
				$composite.appendWhiteSpaceNode();
			}
			if (options.suffixText) {
				$composite.append(`<span class="ignore-for-fhs suffix-text">${options.suffixText}</span>`);
			}
		}
		$composite.append($field);
		if (options.labelOnRight === true) {
			if (options.label || options.xlabel) {
				var $label = this._createLabel(options.label, options);
				$composite.append($label);
				$composite.appendWhiteSpaceNode();
			}
			if (options.suffixText) {
				$composite.append(`<span class="ignore-for-fhs suffix-text">${options.suffixText}</span>`);
			}
		}
		return this;
	},
	addSelectField: function(name, options) {
		options = options || {};
		var $composite = this._createComposite(options);
		if (options.label || options.xlabel) {
			var $label = this._createLabel(options.label, options);
			$composite.append($label);
			$composite.appendWhiteSpaceNode();
		}
		var $field = $('<select data-name="' + name + '"></select>');
		if (options.id) {
			$field.attr('id', options.id);
		}
		if (options.fieldClass) {
			$field.addClass(options.fieldClass);
		}
		if (options.fieldStyle) {
			$field.css(options.fieldStyle);
		}
		if (options.emptyEntry) {
			var forceXlate = options.emptyLabel != undefined;
			var emptyOptions = {
				xlabel: options.emptyXLabel
			};
			var emptyText = this._labelText(options.emptyLabel || '', emptyOptions, forceXlate);
			$field.append('<option value="">' + emptyText + '</option>');
		}
		this._addInputAttributes($field, options);
		$composite.append($field);
		return this;
	},
	addChoiceGroup: function(name, options) {
		options = options || {};
		var $composite = this._createComposite(options);
		if (options.label || options.xlabel) {
			var $label = this._createLabel(options.label, options);
			$composite.append($label);
			$composite.appendWhiteSpaceNode();
		}
		var $field = $('<span class="choice-group" data-name="' + name + '"></select>');
		if (options.id) {
			$field.attr('id', options.id);
		}
		if (options.fieldClass) {
			$field.addClass(options.fieldClass);
		}
		if (options.fieldStyle) {
			$field.css(options.fieldStyle);
		}
		this._addInputAttributes($field, options);
		if (options.entries) {
			options.entries.forEach(entry => {
				var input = $('<input type="' + options.type + '" value="' + entry.value + '"></input>')
				var label = this._createLabel(entry.label, entry);
				$field.append(input).append(label);
				if (options.validation != undefined) {
					this.addDataAttribute(input, 'validation', options);
					this.addDataValidationAttributes(input, options);
				}
				if (entry.fieldClass) {
					input.addClass(entry.fieldClass);
				}
				//				label.attr('for', input.uniqueId().attr('id'));
				//				input.attr('name', name + "-group");
			});
		}
		$composite.append($field);
		return this;
	},
	addTextArea: function(name, options) {
		options = options || {};
		var $composite = this._createComposite(options);
		if (options.label || options.xlabel) {
			var $label = this._createLabel(options.label, options);
			$composite.append($label);
			$composite.appendWhiteSpaceNode();
		}
		var $field = $(`<textarea data-name="${name}"></textarea>`);
		if (options.id) {
			$field.attr('id', options.id);
		}
		if (options.fieldClass) {
			$field.addClass(options.fieldClass);
		}
		if (options.fieldStyle) {
			$field.css(options.fieldStyle);
		}
		this._addTextAreaAttributes($field, options);
		$composite.append($field);
		return this;
	},
	addReadField: function(name, options) {
		options = options || {};
		var tag = options.tag || 'div';
		var $composite = this._createComposite(options);
		var $field = $('<' + tag + ' data-name="' + name + '"></' + tag + '>');
		if (options.id) {
			$field.attr('id', options.id);
		}
		if (options.fieldClass) {
			$field.addClass(options.fieldClass);
		}
		if (options.fieldStyle) {
			$field.css(options.fieldStyle);
		}
		this._addReadAttributes($field, options);
		if (options.labelOnRight !== true) {
			if (options.label || options.xlabel) {
				var $label = this._createLabel(options.label, options);
				$composite.append($label);
				$composite.appendWhiteSpaceNode();
			}
		}
		$composite.append($field);
		if (options.labelOnRight === true) {
			if (options.label || options.xlabel) {
				var $label = this._createLabel(options.label, options);
				$composite.append($label);
				$composite.appendWhiteSpaceNode();
			}
		}
		if (options.innerText != undefined) {
			$field.text(options.innerText);
		}
		return this;
	},
	addInternalLegend: function(name, options) {
		options = options || {};
		var $composite = $(`<div class="dashlet-legend internal-legend"></div>`);
		if (options.compositeClass) {
			$composite.addClass(options.compositeClass);
		}
		this._appendToParent($composite);
		var $field = name != undefined ? $(`<div data-name="${name}"></div>`) : $(`<div></div>`);
		if (options.id) {
			$field.attr('id', options.id);
		}
		if (options.fieldClass) {
			$field.addClass(options.fieldClass);
		}
		if (options.fieldStyle) {
			$field.css(options.fieldStyle);
		}
		this._addInternalLegendAttributes($field, options);
		if (options.xlabel) {
			$field.html(options.xlabel);
		}
		$composite.append($field);
		return this;
	},
	addTable: function(name, options) {
		options = options || {};
		var $composite = this._createComposite(options);
		if (options.label || options.xlabel) {
			var $label = this._createLabel(options.label, options);
			$composite.append($label);
			$composite.appendWhiteSpaceNode();
		}
		var $field = $('<div data-name="' + name + '"></div>');
		if (options.id) {
			$field.attr('id', options.id);
		}
		if (options.fieldClass) {
			$field.addClass(options.fieldClass);
		}
		if (options.fieldStyle) {
			$field.css(options.fieldStyle);
		}
		this._addTableAttributes($field, options);
		$composite.append($field);
		// prepare table
		var dataTable = {
			provider: options.provider
		};
		if (options.rowPrefix) {
			dataTable.rowPrefix = options.rowPrefix;
		}
		if (options.editable != undefined) {
			dataTable.editable = options.editable
		}
		var $table = $('<table data-table="' + JSON.stringify(dataTable).replaceAll('"', '\'') + '"></table>');
		var $thead = $('<thead></thead>');
		var $tbody = $('<tbody></tbody>');
		var $tr = $('<tr></tr>');
		options.rows.forEach(r => {
			var $th = this._createTableHeader(r.label, r);
			this.addDataAttribute($th, 'col', r);
			$tr.append($th);
		});
		$thead.append($tr);
		$table.append($thead).append($tbody);
		$field.append($table);
		return this;
	},
	_createTableHeader: function(label, options) {
		options = options || {};
		var text = (this.settings.xlate && label) ? xlate(label) : label;
		if (options.xlabel) {
			text = options.xlabel;
		}
		var $th = $('<th>' + text + '</th>');
		if (options.labelClass) {
			$th.addClass(options.labelClass);
		}
		return $th;
	},
	openButtonContainer: function(options) {
		options = options || {};
		var $composite = this._createComposite(options);
		this.currentComposite = $composite;
		return this;
	},
	closeButtonContainer: function(options) {
		this.currentComposite = undefined;
		return this;
	},
	addButton: function(action, options, pureDataObject) {
		options = options || {};
		var $composite = this._createComposite(options);
		var label = (options.label) ? (this.settings.xlate ? xlate(options.label) : options.label) : (options.xlabel) ? options.xlabel : '';
		var $btn = $(`<button data-action="${action}">${label}</button>`);
		if (options.btnClass) {
			$btn.addClass(options.btnClass);
		}
		if (options.btnStyle) {
			$btn.css(options.btnStyle);
		}
		if (pureDataObject != undefined) {
			$btn.data(pureDataObject);
		}

		this._addButtonAttributes($btn, options);

		$composite.append($btn);
		return this;
	},
	_createComposite: function(options) {
		if (this.currentComposite == undefined) {
			options = options || {};
			var $composite = $('<div class="field-composite"></div>');
			if (options.compositeClass) {
				$composite.addClass(options.compositeClass);
			}
			if (options.compositeStyle) {
				$composite.css(options.compositeStyle);
			}
			this._appendToParent($composite, options.appendAfter);
			return $composite;
		} else {
			return this.currentComposite;
		}
	},
	_createLabel: function(label, options) {
		options = options || {};
		var text = this._labelText(label, options, this.settings.xlate);
		var $label = $('<label>' + text + '</label>');
		if (options.labelClass) {
			$label.addClass(options.labelClass);
		}
		return $label;
	},
	_appendToParent: function($element, appendAfter) {
		if (appendAfter != undefined) {
			$('*[data-name="' + appendAfter + '"]', this.$fieldset).closest('.field-composite').after($element);
		} else if (this.currentSubFieldset != undefined) {
			this.currentSubFieldset.append($element);
		} else if (this.currentFieldset != undefined) {
			this.currentFieldset.append($element);
		} else {
			this.$fieldset.append($element);
		}
	},
	_labelText: function(label, options, forceXlate) {
		options = options || {};
		return (options.xlabel != undefined) ? options.xlabel : (forceXlate && label) ? xlate(label) : label;
	},
	/** COPY DATA ATTRIBUTES STUFF */
	_copyDataAttributes: function($field, options, blackList) {
		Object.keys(options)
			.filter(k => this._isData(k, blackList))
			.forEach(k => {
				this.addDataAttribute($field, k, options);
			});
	},
	_isData: function(key, blackList) {
		return !blackList.includes(key);
	},
	_addInputAttributes: function($field, options) {
		this._copyDataAttributes($field, options, this._inputAttributesBlackList());
		this.addSimpleAttribute($field, 'name', options);
		this.addSimpleAttribute($field, 'multiple', options);
		this.addSimpleAttribute($field, 'placeholder', options);
	},
	_addTextAreaAttributes: function($field, options) {
		this._addInputAttributes($field, options);
		// need to add 'placeholder', because skipped in InputAttributes
		this.addDataAttribute($field, 'placeholder', options);
	},
	_addReadAttributes: function($field, options) {
		this._copyDataAttributes($field, options, this._readAttributesBlackList());
	},
	_addInternalLegendAttributes: function($field, options) {
		this._copyDataAttributes($field, options, this._internalLegendAttributesBlackList());
	},
	_addTableAttributes: function($field, options) {
		this._copyDataAttributes($field, options, this._tableAttributesBlackList());
	},
	_addButtonAttributes: function($btn, options) {
		this._copyDataAttributes($btn, options, this._buttonAttributesBlackList());
	},
	_inputAttributesBlackList: function() {
		return [
			'id', 'fieldClass', 'fieldStyle', 'name', 'multiple', 'placeholder', 'compositeClass', 'compositeStyle', 'appendAfter', 'label', 'xlabel', 'labelOnRight', 'labelClass', 'suffixText', 'emptyEntry', 'emptyLabel', 'emptyXLabel', 'entries'
		];
	},
	_readAttributesBlackList: function() {
		return [
			'id', 'tag', 'fieldClass', 'fieldStyle', 'innerText', 'compositeClass', 'compositeStyle', 'appendAfter', 'label', 'xlabel', 'labelOnRight', 'labelClass', 'suffixText'
		];
	},
	_internalLegendAttributesBlackList: function() {
		return [
			'id', 'fieldClass', 'fieldStyle', 'compositeClass', 'compositeStyle', 'appendAfter', 'label', 'xlabel', 'labelOnRight', 'labelClass', 'suffixText'
		];
	},
	_tableAttributesBlackList: function() {
		return [
			'id', 'fieldClass', 'fieldStyle', 'provider', 'rowPrefix', 'editable', 'rows', 'compositeClass', 'compositeStyle', 'appendAfter', 'label', 'xlabel', 'labelOnRight', 'labelClass', 'suffixText'
		];
	},
	_buttonAttributesBlackList: function() {
		return [
			'btnClass', 'btnStyle', 'compositeClass', 'compositeStyle', 'appendAfter', 'label', 'xlabel', 'labelOnRight', 'labelClass', 'suffixText'
		];
	},
});